import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Router from './routes';
import { createContext } from "react";
import './css/style.css';
import './css/react-select-css.css'
import './css/bootstrap.min.css';
import './css/responsive.css';
import './css/all.min.css';

const UserProfileContext: any = createContext({});

function App() {

  const setUserAccess = (data: any) => {
    if (!!data) {
      let tempObj: any = {};
      data.forEach((item: any) => {
        tempObj[item?.moduleName] = item;
      });
      setUserProfile(tempObj);
    }
  }

  const [userProfile, setUserProfile] = useState({});

  return (
      <UserProfileContext.Provider value={setUserAccess}>
        <BrowserRouter>
          <Router userAccess={userProfile} />
        </BrowserRouter>
      </UserProfileContext.Provider>
  );
}

export { UserProfileContext };
export default App;
